<div class="flex flex-row gap-[4px]">
  <ng-content select="app-schedule"></ng-content>
</div>
